import {
  PRESSING_HISTORY_FAILED,
  PRESSING_HISTORY_REQUEST,
  PRESSING_HISTORY_SUCCESS,
} from "app/redux/actions/Factory/Pressing/pressingHistory/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const pressingHistoryReducer = function (
  state = INIT_STATE,
  action
) {
  console.log("Reducer received action:", action); // ✅ Log every action received

  switch (action?.type) {
    case PRESSING_HISTORY_REQUEST:
      console.log("Reducer: PRESSING_HISTORY_REQUEST"); // ✅ Log this action
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };

    case PRESSING_HISTORY_SUCCESS:
      console.log("Reducer: PRESSING_HISTORY_SUCCESS", action.payload); // ✅ Log the success payload

      const successState = {
        loading: false,
        data: action?.payload?.data || [],
        totalPage: action?.payload?.totalPage || 0,
        error: {
          isError: false,
          message: null,
        },
      };

      console.log("Reducer returning success state:", successState); // ✅ Log final state
      return successState;

    case PRESSING_HISTORY_FAILED:
      console.log("Reducer: PRESSING_HISTORY_FAILED", action.payload); // ✅ Log the error payload

      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};

      const failedState = {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };

      console.log("Reducer returning failed state:", failedState); // ✅ Log final error state
      return failedState;

    default:
      return state;
  }
};
